/* eslint-disable no-multi-assign */
import jquery from 'jquery';

global.$ = jquery;
global.jQuery = jquery;
window.$ = jquery;
window.jQuery = jquery;

export default jquery;
